import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
import { useNavigate } from "react-router-dom";
import logo from "../assets/logowhite.png";
import shareVideo from "../assets/share.mp4";
import { client } from "../client";

const Login = () => {
  const navigate = useNavigate();

  const responseGoogle = (credentialResponse) => {
    // Decode JWT token from FedCM flow
    const decoded = JSON.parse(
      atob(credentialResponse.credential.split(".")[1])
    );

    localStorage.setItem(
      "user",
      JSON.stringify({
        name: decoded.name,
        googleId: decoded.sub,
        imageUrl: decoded.picture,
      })
    );

    const doc = {
      _id: decoded.sub,
      _type: "user",
      userName: decoded.name,
      image: decoded.picture,
    };

    client.createIfNotExists(doc).then(() => {
      navigate("/", { replace: true });
    });
  };

  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <div className="flex justify-start items-center flex-col h-screen">
        <div className="relative w-full h-full">
          <video
            src={shareVideo}
            type="video/mp4"
            loop
            controls={false}
            muted
            autoPlay
            className="w-full h-full object-cover"
          />
          <div className="absolute flex flex-col justify-center items-center top-0 right-0 left-0 bottom-0 bg-blackOverlay">
            <div className="p-5">
              <img src={logo} width="130px" alt="logo" />
            </div>
            <div className="shadow-2xl">
              <GoogleLogin
                onSuccess={responseGoogle}
                onError={() => {
                  console.log("Login Failed");
                }}
                useOneTap
                use_fedcm_for_prompt={true}
              />
            </div>
          </div>
        </div>
      </div>
    </GoogleOAuthProvider>
  );
};

export default Login;
